import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { Card, CardContent } from "@/components/ui/card";

const AuthLayout: React.FC = () => {
  const { isAuthenticated, user } = useCurrentUser();

  if (isAuthenticated && user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden px-4">
      {/* Card */}
      <div className="relative z-10 w-full max-w-md animate-page-in">
        <Card className="border border-white/60 bg-white/90 shadow-xl shadow-primary/10 backdrop-blur-2xl">
          <CardContent className="p-8 pt-10">
            {/* Brand mark */}
            <div className="mb-8 flex flex-col items-center text-center">
              <div className="mb-4">
                <img src="/steddy-star.svg" alt="Steddy AI" className="h-14 w-14" />
              </div>
              <h1 className="text-2xl font-bold tracking-tight text-foreground">Steddy AI</h1>
              <p className="mt-1 text-sm text-muted-foreground">Intelligent MCA Platform</p>
            </div>

            <Outlet />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AuthLayout;
